import React, { useEffect, useState } from 'react';
import api from '~/services/api';

interface IItem {
  id: number;
}

interface IOrder {
  items: IItem[];
}

interface IQtyRealized {
  eventId: number;
}

const QtyRealized: React.FC<IQtyRealized> = ({ eventId }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get<IOrder[]>(`orders/events/${eventId}`).then(async (response) => {
      const purchases = response.data.reduce((previous, current) => {
        return previous + current.items.length;
      }, 0);

      setTotal(purchases);
    });
  }, [eventId]);

  return <>{total}</>;
};

export default QtyRealized;
